import React, { useEffect, useState } from 'react';

import './AppleLoginButton.css';
import icLogoApple from "./ic_logo_apple.svg";

// 환경변수 또는 기본값 (SSR에서 import.meta 사용 불가)
const APPLE_CLIENT_ID = (typeof process !== 'undefined' && process.env?.VITE_APPLE_CLIENT_ID)
    || 'com.fruitsfamily.webapp';

/**
 * AppleLoginButton
 * @returns {JSX.Element}
 * @constructor
 */
function AppleLoginButton() {
    const clientId = APPLE_CLIENT_ID;
    const [redirectUri, setRedirectUri] = useState('');

    useEffect(() => {
        const hostname = window.location.hostname;

        if (hostname === 'fruitsfamily.com') {
            setRedirectUri('https://fruitsfamily.com/auth/apple/complete');
        } else {
            setRedirectUri('https://staging.fruitsfamily.com/auth/apple/complete');
        }
    }, []);

    const appleLoginUrl = `https://appleid.apple.com/auth/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code%20id_token`;

    const handleClick = () => {
        window.location.href = appleLoginUrl;
    };

    return <button onClick={handleClick} className='AppleLoginButton'>
        <img src={icLogoApple} alt='apple-logo' />
        <div>Apple로 계속하기</div>
    </button>
}

export default AppleLoginButton;
